import {command, queryAll, queryOne, querySearch} from "../utils/api";

const GET_DISPENSARY_LIST_URL = `${process.env.PUBLIC_URL}/api/v1/r/dispensaryList`;
export const GET_DISPENSARY_LIST = "GET_DISPENSARY_LIST";
export const GET_DISPENSARY_LIST_COMPLETED = "GET_DISPENSARY_LIST_COMPLETED";
export const GET_DISPENSARY_LIST_FAILED = "GET_DISPENSARY_LIST_FAILED";
export function getDispensaryList() {
  const queryFilter = {
    order: "name ASC"
  };
  return queryAll(GET_DISPENSARY_LIST_URL, queryFilter, GET_DISPENSARY_LIST, GET_DISPENSARY_LIST_COMPLETED,
    GET_DISPENSARY_LIST_FAILED);
}

export const SEARCH_DISPENSARIES = 'SEARCH_DISPENSARIES';
export const SEARCH_DISPENSARIES_COMPLETED = 'SEARCH_DISPENSARIES_COMPLETED';
export const SEARCH_DISPENSARIES_FAILED = 'SEARCH_DISPENSARIES_FAILED';
export const searchDispensaries = querySearch(GET_DISPENSARY_LIST_URL, SEARCH_DISPENSARIES, SEARCH_DISPENSARIES_COMPLETED,
  SEARCH_DISPENSARIES_FAILED, ['name', 'address', 'phoneNumber']);

export const GET_DISPENSARY = "GET_DISPENSARY";
export const GET_DISPENSARY_COMPLETED = "GET_DISPENSARY_COMPLETED";
export const GET_DISPENSARY_FAILED = "GET_DISPENSARY_FAILED";
export function getDispensary({dispensaryId}) {
  const filter = {
    where: {
      dispensaryId
    }
  };
  return queryOne(GET_DISPENSARY_LIST_URL, filter, GET_DISPENSARY, GET_DISPENSARY_COMPLETED, GET_DISPENSARY_FAILED);
}

export const SELECT_DISPENSARY = "SELECT_DISPENSARY";
export function selectDispensary(dispensaryId) {
  return {type: SELECT_DISPENSARY, payload: {dispensaryId}};
}

const DISPENSARY_URL = `${process.env.PUBLIC_URL}/api/v1/dispensary`;
export const ADD_DISPENSARY = 'ADD_DISPENSARY';
export const ADD_DISPENSARY_COMPLETED = 'ADD_DISPENSARY_COMPLETED';
export const ADD_DISPENSARY_FAILED = 'ADD_DISPENSARY_FAILED';
export const addDispensary = command(DISPENSARY_URL + '/addDispensary', ADD_DISPENSARY, ADD_DISPENSARY_COMPLETED,
  ADD_DISPENSARY_FAILED);

export const UPDATE_DISPENSARY = 'UPDATE_DISPENSARY';
export const UPDATE_DISPENSARY_COMPLETED = 'UPDATE_DISPENSARY_COMPLETED';
export const UPDATE_DISPENSARY_FAILED = 'UPDATE_DISPENSARY_FAILED';
export const updateDispensary = command(DISPENSARY_URL + '/updateDispensary', UPDATE_DISPENSARY,
  UPDATE_DISPENSARY_COMPLETED, UPDATE_DISPENSARY_FAILED);



// WEBPACK FOOTER //
// ./src/Dispensary/actions.js